import z from 'zod';

export const categorySelectSchema = z.object({
  id: z.string().uuid({ message: 'Invalid category ID format' }).nullable(),
  name: z
    .string()
    .min(1, { message: 'Category name cannot be empty' })
    .nullable(),
});

export const procedureEditDataSchema = z.object({
  id: z.string().uuid({ message: 'Invalid procedure ID format' }),
  code: z.string(),
  name: z.string(),
  price: z.number(),
  displayName: z.string(),
  shortDescription: z.string(),
  description: z.string(),
  category: categorySelectSchema,
  duration: z.number(),
  riskLevel: z.enum(['Low', 'Medium', 'High']),
  status: z.enum(['Active', 'Inactive']),
  preparationInstructions: z.string(),
  aftercareInstructions: z.string(),
});

export const procedureEditDataOriginalSchema = procedureEditDataSchema
  .omit({ category: true })
  .merge(z.object({ category: z.string().nullable() }));

export type ProcedureEditDataOriginal = z.infer<
  typeof procedureEditDataOriginalSchema
>;
export type ProcedureEditData = z.infer<typeof procedureEditDataSchema>;
export type CategorySelectData = z.infer<typeof categorySelectSchema>;
